module.exports = __webpack_public_path__ + "static/media/zheng2-2@3x.479d8b42.png";